import { SRP_REASON_CHANGED } from "MODULES/inventories/constants";

export const displayFields = {
  serial_number: {
    label: "Serial #",
    type: "text"
  },
  display_condition: {
    label: "Condition",
    type: "text"
  },
  purchase_order_code: {
    label: "PO #",
    type: "text"
  },
  tag_date: {
    label: "Tag Date",
    type: "month"
  },
  suggested_retail: {
    label: "SRP",
    type: "number"
  },
  exchange_srp: {
    label: "Exchange SRP",
    type: "number"
  },
  srp_condition: {
    label: "SRP Condition",
    type: "text"
  },
  [SRP_REASON_CHANGED]: {
    label: "SRP Reason Changed",
    type: "select"
  }
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/UpdateSrpStatus/constants.js